import type { SelectOption } from '@/components/SearchableSelect'
import { reportMonthsRange } from '@/utils/allocationFormat'
import { monthFromIsoDate, reportMonthLabel } from '../distribution-waterfall/waterfallJeStatus'

export const UHC_ALLOCATE_MONTH_RANGE_START = '2025-01'

export function mergeUhcMonthSelectOptions(
  monthsSummary: Array<{ report_month: string; status: string }>,
  asOf?: Date,
): SelectOption[] {
  const statusByMonth = new Map(monthsSummary.map((row) => [row.report_month, row.status]))
  const end = asOf ?? new Date()
  return reportMonthsRange(UHC_ALLOCATE_MONTH_RANGE_START, end).map((reportMonth) => ({
    id: reportMonth,
    label: reportMonthLabel(reportMonth),
    status: (statusByMonth.get(reportMonth) ?? 'incomplete') as 'complete' | 'incomplete',
  }))
}

export function postedMonthsFromSummary(
  monthsSummary: Array<{ report_month: string; status: string }>,
): string[] {
  return monthsSummary
    .filter((row) => row.status === 'complete')
    .map((row) => `${row.report_month}-01`)
    .map(monthFromIsoDate)
    .filter(Boolean)
}
